// routes
import { routes } from "../../../features/routes/route.tsx";
// axios
import axios from "axios";
// data type
import { PhotoCv } from "../../../data/photographer/photoCv.tsx";
// option
import { ClientOption } from "../../../config/clientOption.tsx";

export const SendCv = async (data: PhotoCv) => {
    const { data: response } = await axios.post(`${routes.api[0].address}/photographer/resume/upload`, data, ClientOption);
    return response.data;
}